"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const addresses = {
    ANGLE: '0x0000000000000000000000000000000000000000',
};
exports.default = addresses;
//# sourceMappingURL=local.js.map